import type { Activity, Page } from '@/scripts/data/types'
import { initHashCheck } from '@/scripts/routing'
import State from './state'
import { getDomRefs, showRoot, hideRoot } from './dom'
import Modals from './modals'
import preloader from './preloader'
import manifest from './manifest'
import carousel from './carousel'
import interactions from './interactions'
import activity from './activity'
import { isMicroModalOpen } from '@/scripts/ui/activityView'
import MicroModal from 'micromodal'
import linkList from '@/scripts/ui/linkList'
import { isArchive } from '@/scripts/config/settings'

type MobileAPI = {
  init(root: HTMLElement): void
  show(): void
  hide(): void
  isInitialized(): boolean
}

function initialize(root: HTMLElement) {
  if (State.initialized) return

  State.rootEl = root
  State.refs = { ...State.refs, ...getDomRefs(root) }

  linkList.renderMobileLinks()
  Modals.init()
  interactions.initPhaseTapDelegation(root)
  activity.initView()
  showRoot(root)
  preloader.show(true)

  manifest
    .load()
    .then(() => carousel.init(root))
    .then(() => {
      activity.setButtonContent(State.day)

      // In archive mode, only handle page navigation, not activities
      initHashCheck({
        onActivity: (activityItem: Activity) => {
          if (isArchive) {
            // In archive mode, ignore activity navigation
            return
          }
          // Navigate carousel to the activity's day
          carousel.scrollToDay(activityItem.day)
          // Open activity detail modal
          activity.openActivityDetail(activityItem)
          interactions.resetPhase()
        },
        onPage: (page: Page) => {
          Modals.openMobileMenuPage(page)
        },
      })
    })

  State.initialized = true
}

function show() {
  if (!State.rootEl) return
  State.rootEl.hidden = false
  State.rootEl.classList.add('is-visible')

  if (isMicroModalOpen('modal-activity')) {
    MicroModal.close('modal-activity')
  }
}

function hide() {
  if (!State.rootEl) return
  interactions.resetPhase()
  hideRoot(State.rootEl)
}

function isInitialized() {
  return State.initialized
}

const MobileMode: MobileAPI = { init: initialize, show, hide, isInitialized }
export default MobileMode
